import commonStyles from '../styles.module.scss'
import useStore from 'base/store'
import { PermissionType } from 'common/types'
import {Text, Button} from 'common/components'
import {
  MilestoneAction,
  MilestoneCheck,
  RequestPushBack,
  useAcceptRequestStatus,
  // isMilestonePassed,
  isAllMilestonesPassed,
  CheckActionsProps,
  MilestoneCheckProps,
} from '..'

export default function DefaultControllerCheckActions({
  role,
  request,
  isRequestLoading,
}: CheckActionsProps) {
  const permissions: PermissionType[] = useStore((state) => state.permissions)
  const {
    mutate: acceptRequestStatus,
    isMutating: isAcceptRequestStatusMutating,
  } = useAcceptRequestStatus(request.uuid)

  const handleStatusAccept = () => acceptRequestStatus()

  const isStatusAcceptDisabled =
    isRequestLoading ||
    !isAllMilestonesPassed(request, [
      'financial-checked',
      'financial-reviewed',
    ])

  const isAllowed = !permissions?.includes('edit default request (fc check)')

  return (
    <div className={commonStyles.checkActions}>
      <div className={commonStyles.checkActionsBlock}>
        <Text size="xs">
          <Text as="span" weight="demiBold">
            Financial controller
          </Text>
          <br />
          responsible to do:
        </Text>
        <div className={commonStyles.checkActionsMilestones}>
          <div>
            <MilestoneCheck
              type="financial-checked"
              request={request}
              disabled={isAllowed}
            />
            <ReviewCheck request={request} disabled={isAllowed} />
          </div>
        </div>
      </div>
      { !isAllowed && (
        <div>
          <Button
            className={commonStyles.checkActionsButton}
            loading={isAcceptRequestStatusMutating}
            disabled={isStatusAcceptDisabled}
            onClick={handleStatusAccept}
          >
            Check has been done
          </Button>
          <RequestPushBack
            requestUuid={request.uuid}
            disabled={isRequestLoading}
          />
        </div>
      )}
    </div>
  )
}

const ReviewCheck = ({request, disabled}: MilestoneCheckProps) => {
  const setControllerReviewOpen = useStore(
    (state) => state.setControllerReviewOpen
  )

  const handleCheck = () => setControllerReviewOpen(true)

  return (
    <MilestoneAction
      disableChecked
      type="financial-reviewed"
      milestones={request.milestones}
      disabled={disabled}
      onClick={handleCheck}
    />
  )
}
